import { useTranslation } from 'react-i18next';
import { Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import Column from 'packages/kakapo-ui-kit/components/grid/Column';
import StarIconSmall from 'packages/kakapo-ui-kit/assets/icons/StarIconSmall';
import OpenFieldIconSmall from 'packages/kakapo-ui-kit/assets/icons/OpenFieldIconSmall';
import RadioButton from 'packages/kakapo-ui-kit/components/forms/controls/RadioButton';

export default function FeedbackQuestionTypeSelector(props: {
	type: graphql.FeedbackQuestionType;
	onChange: (type: graphql.FeedbackQuestionType) => void;
}) {
	const { t } = useTranslation();

	return (
		<>
			<Column p={3}>
				<Flex flexDirection="row">
					<RadioButton
						id="resultTypeRadioButtons-Text"
						label={t('query.composer.resultType.openText')}
						icon={<OpenFieldIconSmall />}
						value="Text"
						checked={props.type === graphql.FeedbackQuestionType.Text}
						onChange={() => props.onChange(graphql.FeedbackQuestionType.Text)}
					/>

					<RadioButton
						id="resultTypeRadioButtons-5starRating"
						label={t('query.composer.resultType.5starRating')}
						icon={<StarIconSmall />}
						value="Stars"
						checked={props.type === graphql.FeedbackQuestionType.Stars}
						onChange={() => props.onChange(graphql.FeedbackQuestionType.Stars)}
					/>

					<RadioButton
						id="resultTypeRadioButtons-StarsAndText"
						label={t('query.composer.resultType.starsAndText')}
						value="StarsAndText"
						checked={props.type === graphql.FeedbackQuestionType.Both}
						onChange={() => props.onChange(graphql.FeedbackQuestionType.Both)}
					/>
				</Flex>
			</Column>
		</>
	);
}
